<div class="LesitungEdit row" *ngIf="Entry && Entry != null">
  <div class="row">
    <div class="row">
      <div class="col edit">
        <AdminCard [Item]="Entry">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="bezeichnung" [(ngModel)]="Entry.bezeichnung">
                <label for="bezeichnung">bezeichnung</label>
              </div>
            </div>
          </div>        
        </AdminCard>
      </div>
    </div>
  </div>
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
